import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

//兄弟组件通信
Vue.prototype.$bus = new Vue();


//路由
import router from "./router/index.js";

//ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

//vuex
import store from "./vuex/index.js";

//Vue.js插件
import plugins from './utils/plugins/plugins.js';
Vue.use(plugins);

//全局引入通用工具与方法
import api from './utils/api.js';
Vue.prototype.$api = api;
import utils from './utils/utils.js';
Vue.prototype.$utils = utils;
import common from './utils/common.js';
Vue.prototype.$common = common;

new Vue({
	render: h => h(App),
	router: router,
	store: store,
}).$mount('#app')